import * as React from 'react';

import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Base styles
        'flex h-10 w-full rounded-input border bg-white px-3 py-2 text-sm text-gray-900',
        'placeholder:text-gray-400',
        // Default state
        'border-gray-200',
        // Focus state with brand colors
        'focus-visible:border-2 focus-visible:border-brand-primary focus-visible:outline-none',
        // Disabled state
        'disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-400 disabled:opacity-50',
        // File input
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
